/**
 * @generated SignedSource<<f11d50a5e09e74eebd9bfdd0c888d974>>
 * @relayHash 1b1f48ad3e26883236acf881fb5df327
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b1f48ad3e26883236acf881fb5df327

import { ConcreteRequest } from 'relay-runtime';
export type QmsSummaryCriticality = "CRITICAL" | "INFO" | "REVIEW" | "WARNING";
export type QmsTypeAiRecommendation = "GP" | "TLC";
export type legacyQmsQuestionnaireByIdQuery$variables = {
  questionnaireId: number;
};
export type legacyQmsQuestionnaireByIdQuery$data = {
  readonly qmsQuestionnaireSummaryById: {
    readonly questionnaire: {
      readonly answers: ReadonlyArray<{
        readonly answer: {
          readonly text: string | null;
        } | null;
        readonly clinicalDecisionSupport: ReadonlyArray<{
          readonly criticality: QmsSummaryCriticality;
          readonly recommendation: string;
        }>;
        readonly missedAnswers: ReadonlyArray<string>;
        readonly qmsId: string;
        readonly question: string;
        readonly shortQuestion: string;
      }>;
      readonly version: string;
    } | null;
    readonly tmc: {
      readonly aiReasoning: string;
      readonly aiRecommendation: QmsTypeAiRecommendation;
    } | null;
    readonly useCase: {
      readonly name: string;
    } | null;
  };
};
export type legacyQmsQuestionnaireByIdQuery = {
  response: legacyQmsQuestionnaireByIdQuery$data;
  variables: legacyQmsQuestionnaireByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "questionnaireId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "questionnaireId",
        "variableName": "questionnaireId"
      }
    ],
    "concreteType": "QuestionnaireSummaryOutput",
    "kind": "LinkedField",
    "name": "qmsQuestionnaireSummaryById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SummaryQuestionnaireQms",
        "kind": "LinkedField",
        "name": "questionnaire",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SummaryQuestionQms",
            "kind": "LinkedField",
            "name": "answers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "qmsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortQuestion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "missedAnswers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AnswerType",
                "kind": "LinkedField",
                "name": "answer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SummaryClinicalDecisionSupportQms",
                "kind": "LinkedField",
                "name": "clinicalDecisionSupport",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recommendation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "criticality",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TelemedicineClassifierQms",
        "kind": "LinkedField",
        "name": "tmc",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiRecommendation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiReasoning",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UseCasesItemOutput",
        "kind": "LinkedField",
        "name": "useCase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "legacyQmsQuestionnaireByIdQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "legacyQmsQuestionnaireByIdQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "1b1f48ad3e26883236acf881fb5df327",
    "metadata": {},
    "name": "legacyQmsQuestionnaireByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f62fd3bca1323e21a14292cdbb8ff06e";

export default node;
